import { useGenericSocket } from "@/hooks/useGenericSocket";
import { SocketTopics } from "@/lib/natsConnection";
import { useCallback } from "react";

export type ICandlePatterns = {
  [key: string]: ICandlePattern;
};

export type ICandlePattern = {
  data: {
    [key: string]: string[];
  };
  timeFrame: string;
  timestamp: number;
};

export type ICandlePatternRow = {
  symbol: string;
  pattern: string;
};

export function useCandlePatterns(interval: string) {
  const handler = useCallback(
    (_: ICandlePatternRow[], newData: ICandlePatterns) => {
      const dataWithInterval = newData[interval];
      return Object.entries(dataWithInterval.data).flatMap(
        ([symbol, patterns]) =>
          patterns.map((pattern) => {
            return {
              symbol,
              pattern,
            };
          }),
      );
    },
    [interval],
  );

  return useGenericSocket<ICandlePatternRow[], ICandlePatterns>(
    SocketTopics.candlePatterns,
    handler,
  );
}
